import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'

import {
  CLEAR_PROJECT_ID,
  CLEAR_PROJECT_ROLE,
  UPDATE_PROJECT_ID,
  UPDATE_PROJECT_ROLE,
  UPDATE_ROLE_STATUS,
} from './constants'

const clearProjectRole = () => []
const clearProjectId = () => null
const updateProjectRole = (prev, { roles }) => roles
const updateRoleStatus = (prev, { enable }) => enable
const updateProjectId = (prev, { id }) => id

const projectRoleReducer = createReducer([], {
  [CLEAR_PROJECT_ROLE]: clearProjectRole,
  [UPDATE_PROJECT_ROLE]: updateProjectRole,
})

const roleStatusReducer = createReducer(false, {
  [UPDATE_ROLE_STATUS]: updateRoleStatus
})

const projectIdReducer = createReducer(null, {
  [CLEAR_PROJECT_ID]: clearProjectId,
  [UPDATE_PROJECT_ID]: updateProjectId
})

export default combineReducers({
  roles: projectRoleReducer,
  isLoaded: roleStatusReducer,
  id: projectIdReducer,
})
